import { Validator } from 'vee-validate';

const dictionary = {
  de: {
    messages:{
      url: () => 'Die Eingabe ist keine gültige URL.',
      required: () => 'Die Eingabe ist erforderlich.',
      more_than_whitespace: () => 'Eine Eingabe, die nur aus Leerzeichen besteht, ist nicht erlaubt.',
      min_select: (field, [minSelect], data) => (minSelect == 1) ? 'Es muss mindestens eine Option ausgewählt werden.':'Es müssen mindestens ' + minSelect + ' Optionen ausgewählt werden.',
      max_select: (field, [maxSelect], data) => (maxSelect == 1) ? 'Es darf nur eine Option ausgewählt werden':'Es dürfen höchstens ' + maxSelect + ' Optionen ausgewählt werden',
      older_than: (field, [age], data) => 'Du musst älter als ' + age + ' Jahre sein.',
      date_format: () => 'Ein gültiges Datum besteht aus TT.MM.JJJJ',
      numeric: () => 'Die Eingabe darf nur aus Ziffern bestehen.',
      min: (field, [length], data) => 'Die Eingabe sollte mindestens ' + length + ' Zeichen beinhalten.',
      max: (field, [length], data) => 'Die Eingabe sollte höchstens ' + length + ' Zeichen beinhalten.',
      email: () => 'Die Eingabe ist keine gültige Email',
      free_email: () => 'Die Email ist nicht verfügbar',
      username: () => 'Die Eingabe ist kein gültiger Benutzername',
      free_username: () => 'Der Benutzername ist nicht verfügbar'
    }
  }
};

export default dictionary;




// WEBPACK FOOTER //
// ./src/js/validation.js